import { render } from "./MetaMarket.vue?vue&type=template&id=354ca5cc&scoped=true"
import script from "./MetaMarket.vue?vue&type=script&lang=js"
export * from "./MetaMarket.vue?vue&type=script&lang=js"

import "./MetaMarket.vue?vue&type=style&index=0&id=354ca5cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-354ca5cc"

export default script